import { render, staticRenderFns } from "./filtroLaudos.vue?vue&type=template&id=4a373c8c&scoped=true&lang=pug"
import script from "./filtroLaudos.vue?vue&type=script&lang=js"
export * from "./filtroLaudos.vue?vue&type=script&lang=js"
import style0 from "./filtroLaudos.vue?vue&type=style&index=0&id=4a373c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a373c8c",
  null
  
)

export default component.exports